import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
//import 'components/icons/Icons.scss';

const IconUpCaret = (props) => <i className="csw-i csw-i-up-caret" aria-hidden="true" {...props}>{' '}</i>;
const IconDownCaret = (props) => <i className="csw-i csw-i-down-caret" aria-hidden="true" {...props}>{' '}</i>;
const IconRightCaret = (props) => <i className="csw-i csw-i-right-caret" aria-hidden="true" {...props}>{' '}</i>;
const IconLeftCaret = (props) => <i className="csw-i csw-i-left-caret" aria-hidden="true" {...props}>{' '}</i>;
const IconCheck = (props) => <i className={classNames('csw-i csw-i-check', props.iconClassName)}
                                aria-hidden="true" {...props}>{' '}</i>;
const IconCSLogo = (props) => <i className="csw-i csw-i-cs-logo" aria-hidden="true" {...props}>{' '}</i>;
const IconCSLogoDark = (props) => <i className="csw-i csw-i-cs-logo-dark" aria-hidden="true" {...props}>{' '}</i>;
const IconHeadHeart = (props) => <i className="csw-i csw-i-headheart" aria-hidden="true" {...props}>{' '}</i>;
const IconMedia = (props) => <i className="csw-i csw-i-media" aria-hidden="true" {...props}>{' '}</i>;

const IconFlag = (props) =>
  <i className={classNames('csw-icon csw-icon-flag', props.iconClassName)}
     aria-hidden="true" {...props}>{' '}</i>;
const IconClose = (props) =>
  <i className={classNames('csw-icon csw-icon-cross', props.iconClassName)}
     aria-hidden="true" {...props}>{' '}</i>;
const IconGear = (props) =>
  <i className={classNames('csw-icon csw-icon-cog', props.iconClassName)} aria-hidden="true" {...props}>{' '}</i>;
const IconMenu = (props) =>
  <i className={classNames('csw-icon csw-icon-menu-dots', props.iconClassName)} aria-hidden="true" {...props} />;
const IconShare = (props) =>
  <i className={classNames('csw-icon csw-icon-share', props.iconClassName)} aria-hidden="true" {...props} />;
const IconXTwitter = (props) =>
  <i className={classNames('csw-icon csw-icon-x-twitter', props.iconClassName)} aria-hidden="true" {...props}/>;
const IconFacebook = (props) =>
  <i className={classNames('csw-icon csw-icon-facebook', props.iconClassName)} aria-hidden="true" {...props} />;
const IconLinkedIn = (props) =>
  <i className={classNames('csw-icon csw-icon-linkedin', props.iconClassName)} aria-hidden="true" {...props} />;
const IconInfo = (props) =>
  <i className={classNames('csw-i csw-icon-info', props.iconClassName)} aria-hidden="true" {...props}>{' '}</i>;
const IconGameMenu = (props) => <i className="csw-i csw-i-game-menu" aria-hidden="true" {...props}>{' '}</i>;
const IconGameRedGem = (props) =>
  <i className={classNames('csw-i csw-i-game-red-gem', props.iconClassName)}
     aria-hidden="true" {...props}>{' '}</i>;
const IconGameRedGemEmpty = (props) =>
  <i className={classNames('csw-i csw-i-game-red-gem-empty', props.iconClassName)}
     aria-hidden="true" {...props}>{' '}</i>;
const IconLock = (props) =>
  <i className={classNames('csw-i csw-i-lock', props.iconClassName)} aria-hidden="true" {...props} >{' '}</i>;
const IconRadio = (props) =>
  <i className={classNames('csw-i csw-i-radio', props.iconClassName)} aria-hidden="true" {...props} >{' '}</i>;
const IconLightBulb = (props) =>
  <i className={classNames('csw-i csw-i-lightbulb', props.iconClassName)} aria-hidden="true" {...props} >{' '}</i>;

IconCheck.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconClose.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconMenu.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconGear.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconShare.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconXTwitter.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconFacebook.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconLinkedIn.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconInfo.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconGameRedGem.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconGameRedGemEmpty.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconFlag.propTypes /* remove-proptypes */ = {
  iconClassName: PropTypes.string
};
IconLock.propTypes = {
  iconClassName: PropTypes.string
};
IconRadio.propTypes = {
  iconClassName: PropTypes.string
};
IconLightBulb.propTypes = {
  iconClassName: PropTypes.string
};


export {
  IconCSLogo,
  IconCSLogoDark,
  IconUpCaret,
  IconDownCaret,
  IconRightCaret,
  IconCheck,
  IconClose,
  IconFlag,
  IconGear,
  IconGameMenu,
  IconGameRedGem,
  IconGameRedGemEmpty,
  IconInfo,
  IconFacebook,
  IconLeftCaret,
  IconLightBulb,
  IconHeadHeart,
  IconLinkedIn,
  IconLock,
  IconMedia,
  IconMenu,
  IconRadio,
  IconShare,
  IconXTwitter,
};
